/*
 ハンバーガーメニューの切り替え
 */
var MenuToggle = function() {
    this.$body = $('body');
    this.$menuBtn = $('#js-menuBtn');
    this.$menu = $('#js-menu');
    this.$wrap = $('#js-wrap');
    this.$overlay = $('#js-overlay');
    this.$window = $(window);
    this.menuWidth = this.$menu.width();
    this.isOpen = false;
    this.scrollToggle = require('./scrollToggle');
    require('TweenMax');
};

MenuToggle.prototype = {
    toggle: function(isOpen){
        var _this = this;
        _this.isOpen = !_this.isOpen;
        var x = (_this.isOpen === true)? 0: -(_this.menuWidth);
        if(_this.isOpen){
            _this.$overlay.addClass('is-visible');
            _this.scrollToggle.forbid();
        }else{
            _this.$overlay.removeClass('is-visible');
            _this.scrollToggle.allow();
        }
        //animation
        TweenMax.to('#js-menu', 0.3, {
            x: x,
            ease: Power1.easeOut
        });
        TweenMax.to('#js-content', 0.3, {
            x: x + _this.menuWidth,
            ease: Power1.easeOut
        });
        TweenMax.to('#js-globalHeader', 0.3, {
            x: x + _this.menuWidth,
            ease: Power1.easeOut
        });
    },
    reset: function(){
        var _this = this;
        var x = (_this.isOpen === false)? 0: -(_this.menuWidth);
        _this.menuWidth = _this.$menu.width();
        if (_this.isOpen === false) {
            TweenMax.set('#js-menu', {
                x: -(_this.menuWidth)
            });
            TweenMax.set('#js-content', {
                x: x
            });
            TweenMax.set('#js-globalHeader', {
                x: x
            });
            _this.$menuBtn.removeClass('is-open');
            _this.$wrap.css({'overflow': 'auto'});
            _this.scrollToggle.allow();
            _this.$overlay.removeClass('is-visible');
        }
    },
    init: function() {
        var _this = this;
        TweenMax.set('#js-menu', {
            x: -(_this.menuWidth)
        });
        _this.$menuBtn.on('click', function(e){
            e.preventDefault();
            _this.toggle(_this.isOpen);
        });
        _this.$overlay.on('click', function(e){
            e.preventDefault();
            _this.toggle(_this.isOpen);
        });
        var timer = false;
        $window.on('resize', function(){
            if (timer !== false) {
                clearTimeout(timer);
            }
            timer = setTimeout(_this.reset.bind(_this), 50);
        });

        _this.$overlay.on('touchmove', function(e) {
            e.preventDefault();
        });
    }
};

module.exports = MenuToggle;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/MenuToggle.js
 **/